export default __webpack_public_path__ + "images/Anteriror_blue.9cf992f0cd4a8ed7229d449eae0af5aa.png";